import { Controller } from "@hotwired/stimulus"

// Make a <details> behave like a menu.
//
// A <details> only closes when its own summary is clicked, so an open menu
// stays open while you click elsewhere on the page — and a menu that will not
// go away is worse than a pair of buttons.
//
// Not extracted from picker_controller, which has the same two listeners for
// the same reason but also owns a server-backed search. Sharing would have
// meant one controller doing two unrelated jobs; the listeners are eight
// lines.
export default class extends Controller {
  connect() {
    this.closeOnOutsideClick = (event) => {
      if (!this.element.open || this.element.contains(event.target)) return

      // A CONFIRM DIALOG is an outside click, and closing on it broke every
      // destructive item in a menu.
      //
      // Turbo renders its confirm outside this <details>, so answering it
      // fired this listener, set open = false, and a closed <details> hides
      // its contents — taking the mid-flight form with it. "Stop this goal"
      // looked like it did nothing at all.
      //
      // A submit already in progress owns the interaction; the menu closes
      // when the response arrives and re-renders the page.
      if (this.submitting) return

      this.element.open = false
    }

    // Set before the confirm appears, because Turbo fires this on the form's
    // submit event and only then asks.
    this.markSubmitting = () => { this.submitting = true }

    this.element.addEventListener("submit", this.markSubmitting, true)

    this.closeOnEscape = (event) => {
      if (event.key !== "Escape" || !this.element.open) return

      this.element.open = false
      // Focus back to the control that opened it, so keyboard use does not
      // dump you at the top of the document.
      this.element.querySelector("summary")?.focus()
    }

    // Capture phase: an item may navigate or submit, taking the menu out of
    // the DOM before a bubbling listener would run.
    document.addEventListener("click", this.closeOnOutsideClick, true)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick, true)
    document.removeEventListener("keydown", this.closeOnEscape)
    this.element.removeEventListener("submit", this.markSubmitting, true)
  }
}
